// import React from "react";

// function ImgSlider({ slides }) {
//   return (
//     <div className="img-slider">
//       <div className="swiper-wrapper">
//         {slides.map((item, i) => (
//           <div key={i} className="swiper-slide">
//             <div className="slider-card wow zoomIn slow">
//               <img
//                 data-src={item.img}
//                 alt={`imagem ${item.title}`}
//                 className="swiper-lazy bg img-cover"
//               />
//               <div className="container">
//                 <div className="content">
//                   <div className="row justify-content-between">
//                     <div className="text-container">
//                       <div className="info">
//                         <h2 className="font-palast-regular ltspc-20">
//                           <span>{item.title}</span>{" "}
//                           <span className="fsz-20 ms-20">{item.subTitle}</span>
//                         </h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//       <div className="arrows">
//         <div className="swiper-button-prev">
//           <i className="far fa-long-arrow-left"></i>
//         </div>
//         <div className="swiper-button-next">
//           <i className="far fa-long-arrow-right"></i>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ImgSlider;
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function ImgSlider({ slides }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: "ondemand",
    autoplay: false,
    autoplaySpeed: 3000,
    focusOnSelect: true,
    prevArrow: (
      <div className="custom-prev-arrow">
        <i className="far fa-long-arrow-left"></i>
      </div>
    ),
    nextArrow: (
      <div className="custom-next-arrow">
        <i className="far fa-long-arrow-right"></i>
      </div>
    ),
  };

  return (
    <div className="img-slider">
      <Slider {...settings}>
        {slides.map((item, i) => (
          <div key={i} className="swiper-slide">
            <div className="slider-card">
              <img
                src={item.img}
                alt={`imagem ${item.title}`}
                className="img-cover"
                loading="lazy"
              />
              
                <div className="text-container">
                  <div className="info">
                    <h2 className={`font-palast-regular fsz-65 text-uppercase ltspc-20`}>
                      <span>{item.title}</span>{" "}
                      <span className="fsz-20 ms-20">{item.subTitle}</span>
                    </h2>
                  </div>
                </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default ImgSlider;
